import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import DropdownOptions from "../../../constants/DropdownOptions";
import Button from "../../FormElement/Button";
import Dropdown from "../../FormElement/Dropdown";
import InputFiled from "../../FormElement/InputFiled";


const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class TrucklineForm extends Component {
  render() {
    const {
      handleChange,
      handleError,
      trucklineInfo,
      buttonLabel,
      formLabel,
      createTruckline,
      isValid,
      edited
    } = this.props;
    const truckLabel =
      trucklineInfo.truckLineTypeId == "2"
        ? "Name of Truckline"
        : "Name of Truck";
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Dropdown
                value={trucklineInfo.truckLineTypeId}
                label="Truckline Type"
                required
                type="text"
                name="truckLineTypeId"
                options={DropdownOptions.trucklineTypes}
                validations={["required"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label={truckLabel}
                type="text"
                name="name"
                required
                value={trucklineInfo.name}
                validations={["required", "maxSize"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Contact Phone Number"
                type="text"
                name="contact"
                required
                value={trucklineInfo.contact}
                validations={["onlyNumber", "required"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Address"
                type="text"
                name="address"
                value={trucklineInfo.address}
                multiline
                rows={2}
                rowsMax={4}
                validations={["aboveMaxSize"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Extra Comments"
                type="text"
                name="comment"
                value={trucklineInfo.comment}
                multiline
                rows={2}
                rowsMax={4}
                validations={["aboveMaxSize"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/farmsetup/trucklines" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isValid}
              onclick={createTruckline}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default TrucklineForm;



// WEBPACK FOOTER //
// ./src/components/private/Trucklines/TrucklineForm.js